import { Component } from '@theme/component';

/**
 * Hero Logo Component
 * Manages the interaction between hero logo and header logo on homepage
 */
class HeroLogoComponent extends Component {
  constructor() {
    super();
    this.headerLogo = null;
    this.heroLogo = null;
    this.header = null;
    this.isHeaderLogoVisible = false;
    this.scrollHandler = null;
  }

  connectedCallback() {
    super.connectedCallback();

    // Only run on homepage
    if (document.location.pathname !== '/') return;

    this.init();
  }

  init() {
    this.headerLogo = document.querySelector('[data-homepage-logo]');
    this.heroLogo = document.querySelector('.hero--logo .hero__logo');
    this.header = document.querySelector('#header-component');

    if (!this.headerLogo || !this.heroLogo || !this.header) return;

    // console.log('Hero logo component initialized:', {
    //   headerLogo: !!this.headerLogo,
    //   heroLogo: !!this.heroLogo,
    //   header: !!this.header,
    //   heroLogoElement: this.heroLogo,
    // });

    this.setupScrollDetection();
  }

  setupScrollDetection() {
    // Use scroll events instead of IntersectionObserver for sticky elements
    this.scrollHandler = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.scrollHandler, { passive: true });

    // Initial check
    this.handleScroll();

    // console.log('Scroll detection setup for hero logo:', this.heroLogo);
  }

  handleScroll() {
    if (!this.header || !this.heroLogo) return;

    const headerRect = this.header.getBoundingClientRect();
    const heroLogoRect = this.heroLogo.getBoundingClientRect();

    // Check if hero logo is under the header
    const isHeroLogoUnderHeader = heroLogoRect.bottom <= headerRect.top;

    // console.log('Scroll detection:', {
    //   heroLogoBottom: heroLogoRect.bottom,
    //   headerBottom: headerRect.bottom,
    //   isUnderHeader: isHeroLogoUnderHeader,
    //   currentState: this.isHeaderLogoVisible ? 'visible' : 'hidden',
    //   scrollY: window.scrollY,
    // });

    if (isHeroLogoUnderHeader && !this.isHeaderLogoVisible) {
      // Hero logo is under header, show header logo
      // console.log('Showing header logo');
      this.showHeaderLogo();
    } else if (!isHeroLogoUnderHeader && this.isHeaderLogoVisible) {
      // Hero logo is visible again, hide header logo
      // console.log('Hiding header logo');
      this.hideHeaderLogo();
    }
  }

  showHeaderLogo() {
    if (!this.headerLogo || !this.header) return;

    // console.log('Adding header background visibility');
    this.headerLogo.classList.add('header-logo--visible');
    this.header.classList.add('header--background-visible');
    this.isHeaderLogoVisible = true;
  }

  hideHeaderLogo() {
    if (!this.headerLogo || !this.header) return;

    // console.log('Removing header background visibility');
    this.headerLogo.classList.remove('header-logo--visible');
    this.header.classList.remove('header--background-visible');
    this.isHeaderLogoVisible = false;
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

// Initialize the component when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Only run on homepage
  if (document.location.pathname !== '/') return;

  // Create and connect the component
  const heroLogoComponent = new HeroLogoComponent();
  document.body.appendChild(heroLogoComponent);
});

// Register the component for future use
customElements.define('hero-logo-component', HeroLogoComponent);
